<div class="container-fluid modal">
  <div class="modal-content setup-modal" role="dialog" aria-modal="true" aria-labelledby="setup-modal-title">
    <div class="setup-modal-header">
      <h5 id="setup-modal-title" class="setup-modal-title m-0">
        {{ "SETUP" | translate }}
      </h5>
      <button type="button" class="setup-modal-close" (click)="cancel.emit()"
        [attr.aria-label]="'DEVICES_NO' | translate">
        <svg aria-hidden="true" viewBox="0 0 24 24" width="14" height="14">
          <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <div class="setup-modal-body">
      <p class="setup-modal-message m-0">
        {{ "SETUP_OPTION_QUESTION" | translate }}
      </p>

      <div class="setup-modal-actions">
        <div class="button-style-white rounded p-2 d-flex justify-content-center align-items-center cursor-pointer"
          (click)="optionSelected.emit(false)">
          <span class="me-2">Partial</span><img src="assets/device/partial-reconfig.svg">
        </div>
        <div class="button-style-white rounded p-2 d-flex justify-content-center align-items-center cursor-pointer"
          (click)="optionSelected.emit(true)">
          <span class="me-2">Force Full</span><img src="assets/device/full-reconfig.svg">
        </div>
      </div>
    </div>
  </div>
</div>
